import clsx from "clsx";
import { CommonSectionTitle } from "@Components/common-section-title/CommonSectionTitle";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { CMSImageType } from "@Types/Contentful";
import classes from "./SectionTitleIconDescription.module.scss";

export interface SectionTitleIconDescriptionProps {
  icon?: CMSImageType;
  title: string;
  description: any;
  centeredDescription: boolean;
}

export default function SectionTitleIconDescription(
  props: SectionTitleIconDescriptionProps
) {
  const { icon, title, description, centeredDescription } = props;

  return (
    <div className={classes["title-section"]}>
      <CommonSectionTitle title={title} icon={icon} />
      {description && (
        <div
          className={clsx(
            classes["title-section__intro-copy"],
            centeredDescription && classes["title-section__intro-copy--center"],
            classes["title-section-plain_text"]
          )}
        >
          <CmsTextEditorContent content={description} />
        </div>
      )}
    </div>
  );
}
